import { createAction } from './utils';
const reducer = 'ROUTES';
const navigate = createAction(reducer, 'NAVIGATE');
export { navigate };
